import React, {Component} from 'react'
import {connect} from 'react-redux'
import AuthorizeCallback from '../../../components/authentication/oauth/AuthorizeCallback'

class AuthorizeCallbackPage extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        console.log('render..')
        return (<AuthorizeCallback />)
    }
}

export default connect(
    store => ({
        user: store.authen != null && store.authen.user != null ? store.authen.user : null,
        messages: store.theme.messages,
        locale: store.theme.locale,
    }),
    {},
)(AuthorizeCallbackPage)
